/**
 * Developer partners whose homeowners can use MNZL Flex.
 *
 * Each partner gets a co-branded landing page at `/flex/<slug>`. Copy comes
 * from `site.flex.partners.<slug>.*` in the locale files; this file holds the
 * data that does not translate.
 */
export type Partner = {
  slug: string;
  /** Partner name as it should be printed, in both languages. */
  name: { en: string; ar: string };
  /** Compounds/projects where Flex is live, in both languages. */
  compounds: { en: string[]; ar: string[] };
  /** An illustrative unit for the app mock on the partner's page. */
  sampleUnit: { en: string; ar: string };
  /**
   * The partner's own logo in `public/partners/` (SVG, dark on light), with
   * its intrinsic size so the browser knows the ratio before it loads.
   * Optional so a new partner can launch before its mark is cleared.
   */
  logo?: { src: string; width: number; height: number };
  /** Accent used for the partner badge (kept inside the brand palette). */
  accent: string;
};

export const PARTNERS: readonly Partner[] = [
  {
    slug: "palm-hills",
    name: { en: "Palm Hills Developments", ar: "بالم هيلز للتعمير" },
    compounds: { en: ["The Crown"], ar: ["ذا كراون"] },
    sampleUnit: { en: "Villa 214, The Crown", ar: "فيلا 214، ذا كراون" },
    logo: { src: "/partners/palm-hills.svg", width: 4428, height: 748 },
    accent: "#A8E9CB",
  },
  {
    slug: "marakez",
    name: { en: "Marakez", ar: "مراكز" },
    compounds: { en: ["Ramla", "District 5"], ar: ["رملة", "ديستريكت 5"] },
    sampleUnit: { en: "Apartment 12, District 5", ar: "شقة 12، ديستريكت 5" },
    logo: { src: "/partners/marakez.svg", width: 173, height: 55 },
    accent: "#E9E4F6",
  },
] as const;

export const getPartner = (slug: string | undefined): Partner | undefined =>
  PARTNERS.find((partner) => partner.slug === slug);

export const partnerSlugs = PARTNERS.map((partner) => partner.slug);
